import React from 'react';
import PropTypes from 'prop-types';
export default function Layout({ children }) {
    return (
        <div className="w-full lg:w-lg m-auto bg-white rounded-lg shadow-md">
            {children}
        </div>
    );
}

// PropTypes validation
Layout.propTypes = {
    children: PropTypes.node.isRequired,
};
